// none — slot-layout primitive (empty variant).
//
// Used by `empty-with-label` / `empty-shelf` / `empty-bin` variants —
// fixtures rendered without any products in their volume. Composer +
// stage's populateComics call still happens but produces zero comic
// entries; the fixture renders Body + Lid + label only.
//
// This primitive exists so the manifest schema is uniform across all
// variants — empty is just another `layoutAlgorithm` value, not a
// missing field. Studio v2's UI can treat all variants the same way.

import { registerSlotLayout } from "./index.js";

function computeNone({ anchor }) {
	return {
		slots: [],
		extras: {
			laneCenter:     anchor.position.clone(),
			laneSize:       { x: 0, y: 0, z: 0 },
			slotStepVector: null,
			slotQuaternion: null,
			heroExtract:    anchor.position.clone(),
			maxSlots:       0,
			slotCount:      0,
		},
	};
}

registerSlotLayout("none", computeNone);
export { computeNone };
